// extracted by mini-css-extract-plugin
module.exports = {"globalWrapper":"layout-module--globalWrapper--2o5Es","mainWrapper":"layout-module--mainWrapper--2B7Uv","main":"layout-module--main--2yme8","full":"layout-module--full--2UlQv"};